import { Chip } from '@material-ui/core';
import { ExamTaskGroupSolutionAssigmentState } from '../../../enum/examTaskGroupSolutionAssgmentState';
import CheckIcon from '@mui/icons-material/Check';

const style = {
  margin: '6px 0 6px 0px',
  height: '20px',
  color: 'rgba(44, 45, 62, 0.7)',
  backgroundColor: 'white',
  fontWeight: 700,
  size: '12px',
  lineHeight: '20px',
};

const emptyStyle = {
  margin: '6px 0 6px 0px',
  height: '20px',
  color: 'rgba(44, 45, 62, 0.7)',
  fontWeight: 700,
  size: '12px',
  lineHeight: '20px',
};

export const statusAssignmentRgz = (status: ExamTaskGroupSolutionAssigmentState): JSX.Element => {
  switch (status) {
    case ExamTaskGroupSolutionAssigmentState.AssignedToCurrentUser:
      return (
        <Chip
          style={style}
          icon={<CheckIcon style={{ color: 'rgba(44, 45, 62, 0.7)' }} />}
          variant="outlined"
          label="Ja"
        ></Chip>
      );
    case ExamTaskGroupSolutionAssigmentState.AssignedToOtherExaminer:
      return (
        <Chip
          style={style}
          icon={<CheckIcon style={{ color: 'rgba(44, 45, 62, 0.7)' }} />}
          variant="outlined"
          label="CZWO"
        ></Chip>
      );
    case ExamTaskGroupSolutionAssigmentState.Unassigned:
      return <div style={emptyStyle}></div>;
  }
};
